export default "__VITE_ASSET__41e73212__"